
import React, { useState } from 'react';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is IV vitamin therapy and how does it work?',
      answer: 'IV vitamin therapy delivers nutrients directly into your bloodstream through an intravenous drip, bypassing the digestive system for 100% bioavailability. This allows for immediate absorption and utilization of vitamins, minerals, and other nutrients at the cellular level, providing faster and more effective results than oral supplements.'
    },
    {
      question: 'Is IV therapy safe?',
      answer: 'Yes, IV therapy is extremely safe when administered by qualified medical professionals. All our treatments are performed in a sterile environment using pharmaceutical-grade nutrients. Our medical team monitors patients throughout treatment, and adverse reactions are rare. We conduct thorough health assessments before treatment to ensure safety.'
    },
    {
      question: 'How long does an IV treatment take?',
      answer: 'Treatment duration varies depending on the specific IV formulation. Most treatments take between 30-90 minutes. Hydration IVs typically take 30-45 minutes, while more complex formulations like high-dose vitamin C or detox IVs may take 60-90 minutes. You can relax comfortably during the entire process.'
    },
    {
      question: 'How often should I get IV therapy?',
      answer: 'Frequency depends on your individual health goals and needs. For general wellness, monthly treatments are often sufficient. For specific health concerns, athletic performance, or during illness recovery, weekly or bi-weekly treatments may be recommended. Our medical team will create a personalized schedule based on your goals.'
    },
    {
      question: 'What should I expect during my first IV treatment?',
      answer: 'Your first visit includes a health consultation to determine the best IV formulation for your needs. You\'ll relax in a comfortable treatment chair while a small IV catheter is inserted. Most patients feel relaxed during treatment and notice increased energy and well-being immediately afterward. Some may experience mild warmth or taste sensations.'
    },
    {
      question: 'Can IV therapy help with hangovers?',
      answer: 'Absolutely! Our Hydration Plus IV is specifically designed for hangover relief. It rapidly rehydrates your body, replenishes lost electrolytes, and provides B-vitamins to help metabolize alcohol byproducts. Many patients feel significantly better within 30-60 minutes of treatment.'
    },
    {
      question: 'Are there any side effects?',
      answer: 'Side effects are rare and typically mild. Some patients may experience slight bruising at the injection site, temporary warmth or flushing, or a metallic taste during treatment. These effects are normal and resolve quickly. Serious adverse reactions are extremely rare when treatments are properly administered.'
    },
    {
      question: 'How is IV therapy different from taking oral vitamins?',
      answer: 'IV therapy provides 100% bioavailability compared to 10-30% absorption from oral supplements. Nutrients go directly into your bloodstream, bypassing digestive limitations and providing immediate cellular benefits. This allows for higher therapeutic doses and faster results than what\'s possible with oral supplementation.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            <strong>IV Therapy</strong> FAQ
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
            Get answers to the most common questions about IV vitamin therapy and how it can benefit your health.
          </p>
        </div>

        <div className="space-y-4 lg:space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 lg:px-8 py-4 lg:py-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-lg lg:text-xl font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-2xl text-orange-600 flex-shrink-0`}></i>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 lg:px-8 pb-4 lg:pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-2xl p-6 lg:p-8 text-white">
            <h3 className="text-xl lg:text-2xl font-bold mb-4">
              Ready to Experience IV Therapy?
            </h3>
            <p className="text-lg mb-6 opacity-90">
              Our IV therapy specialists are here to help you choose the perfect treatment for your wellness goals.
            </p>
            <button className="bg-white text-orange-600 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Schedule Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
